import React from 'react';
import { Eye } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { AutoSaveIndicator } from './AutoSaveIndicator';

interface ReportEditHeaderProps {
  reportId: string | undefined;
  autoSaveStatus: 'idle' | 'saving' | 'saved' | 'error';
  lastSavedAt: Date | null;
}

export const ReportEditHeader: React.FC<ReportEditHeaderProps> = ({
  reportId,
  autoSaveStatus,
  lastSavedAt,
}) => (
  <div className="mb-8">
    <div className="flex items-center justify-between mb-3 gap-4">
      <h1 className="text-4xl font-bold text-gray-900">Editar Report</h1>
      <div className="flex items-center gap-4">
        <AutoSaveIndicator status={autoSaveStatus} lastSavedAt={lastSavedAt} />
        {reportId && (
          <Button variant="outline" asChild className="flex items-center gap-2">
            <a href={`/app/reports/${reportId}`} target="_blank" rel="noopener noreferrer">
              <Eye className="w-4 h-4" />
              Visualizar
            </a>
          </Button>
        )}
      </div>
    </div>
    <p className="text-lg text-gray-600">
      Edite seu report modificando e configurando componentes
    </p>
  </div>
);
